(function(){
    'use strict';
    
    jcu_js_v1.fn.initCourseDetails = function(){
        var accordionButtons = document.querySelectorAll(".jcu-v1__accordion__btn");
        accordionButtons.forEach(function(button) {
            button.addEventListener("click", jcu_js_v1.fn.toggleAccordion);
        });
        //remove the h1 from the Handbook 
        jcu_js_v1.fn.removeH1('#accordion-3-panel');
    }
   

    jcu_js_v1.fn.toggleAccordion = function(e) {
        e.preventDefault();

        var accordionButton = e.target;
        var panelId = accordionButton.getAttribute('aria-controls');
        var accordionPanel = document.getElementById(panelId);
        
        var isTransitioning = accordionPanel.classList.contains('toggling');
        if (isTransitioning) {
            return;
        }

        var isExpanded = accordionPanel.classList.contains('expanded');

        // Expand
        if (!isExpanded) {
            accordionButton.setAttribute('aria-expanded', 'true');

            accordionPanel.classList.add('toggling');
            accordionPanel.classList.remove('collapsed');
            
            accordionPanel.style.height = accordionPanel.scrollHeight + "px";

            var transitionDuration = parseFloat(getComputedStyle(accordionPanel)['transitionDuration']) * 1000;
            
            setTimeout(function() {
                accordionPanel.classList.remove('toggling');
                accordionPanel.classList.add('expanded');
                accordionPanel.style.height = '';

            }, transitionDuration);
            
        }

        // Collapse
        else {
            accordionButton.setAttribute('aria-expanded', 'false');

            accordionPanel.style.height = accordionPanel.getBoundingClientRect().height + "px";
            accordionPanel.classList.remove('expanded');
            accordionPanel.classList.add('toggling');
        
            var transitionDuration = parseFloat(getComputedStyle(accordionPanel)['transitionDuration']) * 1000;

            setTimeout(function() {
                accordionPanel.style.height = '';
        
                setTimeout(function() {
                    accordionPanel.classList.remove('toggling');
                    accordionPanel.classList.add('collapsed');
                    accordionPanel.style.height = '';

                }, transitionDuration);

            }, 0);

        }
    }
    jcu_js_v1.fn.initCourseDetails();
    
}());
